import { render, staticRenderFns } from "./MakeService.vue?vue&type=template&id=2c7a32fa&scoped=true"
import script from "./MakeService.vue?vue&type=script&lang=js"
export * from "./MakeService.vue?vue&type=script&lang=js"
import style0 from "./MakeService.vue?vue&type=style&index=0&id=2c7a32fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7a32fa",
  null
  
)

export default component.exports